import { CommonModule } from '@angular/common';
import { Directive, HostListener, NgModule } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GdprNoticeDialogComponent } from '@telespot/ui';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appPrivacyPopupTrigger]',
    standalone: false
})
export class PrivacyPopupTriggerDirective {
  @HostListener('click') onclick() {
    this.openDialog();
  }

  openDialog() {
    this._dialog.open(GdprNoticeDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      hasBackdrop: true,
      disableClose: false,
    });
  }

  constructor(private _dialog: MatDialog) {}
}

@NgModule({
  declarations: [PrivacyPopupTriggerDirective],
  imports: [CommonModule],
  exports: [PrivacyPopupTriggerDirective],
  providers: [],
})
export class PrivacyPopupTriggerModule {}
